<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState } from 'vuex'
  import { getSocialMediaIconForSource } from '@/helper'
  import ModuleTitle from '@/components/layout/ModuleTitle'

  export default {
    name: 'WebNews',
    components: {
      ModuleTitle,
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
    data() {
      return {
        clampLines: 12,
        maxRecordsToShow: this.options.options.maxRecords,
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
      news() {
        return this.options.results.news
      },
      showMore() {
        return this.maxRecordsToShow < this.news.length
      },
    },
    methods: {
      viewMore() {
        this.maxRecordsToShow += this.options.options.maxRecords
      },
      getSocialMediaIconForSource,
      showTitle(title, desc) {
        return desc ? desc.indexOf(title && title.slice(0, -4)) === -1 : true
      },
    },
  }
</script>
